<fullscreen-page>

  <content-column helpSwitch="true" look="light">
    <div slot="content" class="p-2 flex-fill overflow-hidden">

      <dx-data-grid id="dataSourceGrid"
                    #dataSourceGrid
                    [dataSource]="productDataSources"
                    keyExpr="id"
                    (onToolbarPreparing)="onToolbarPreparing($event)"
                    [showBorders]="true"
                    [allowColumnReordering]="true"
                    [repaintChangesOnly]="true"
                    [rowAlternationEnabled]="true"
                    [allowColumnResizing]="true"
                    (onRowRemoved)="onRowRemoved($event)"
                    [height]="'100%'"
                    [selection]="{ mode: 'multiple', showCheckBoxesMode: 'always', allowSelectAll: false}"
                    (onSelectionChanged)="onSelectionChanged($event)"
                    (onRowPrepared)="onRowPrepared($event)">
        <dxo-scrolling mode="virtual" showScrollbar="always"></dxo-scrolling>
        <dxo-search-panel [visible]="true"
                          [width]="240"
                          placeholder="Suche …">
        </dxo-search-panel>
        <dxo-search enabled="true"></dxo-search>
        <dxo-editing mode="cell"
                     [allowAdding]="false"
                     [allowUpdating]="false"
                     [allowDeleting]="true"></dxo-editing>
        <dxo-paging enabled="true"></dxo-paging>
        <dxo-search-panel enabled="true"></dxo-search-panel>
        <div *dxTemplate="let toolbaritem of 'newDataSourceButtonTemplate'">
          <div id="addButton" class="d-flex gap-2">
            <dx-button stylingMode="text"
                       type="default"
                       text="{{ 'Neuer Lieferant' | translate }}"
                       (onClick)="showAddOrUpdateDataSource()">

            </dx-button>
          </div>
        </div>
        <div *dxTemplate="let toolbaritem of 'applyDataSourceChangesButtonTemplate'">
          <div id="applyDataSourceChangesButton" class="d-flex gap-2">
            <dx-button stylingMode="text"
                       [disabled]="!isApplyDataSourceButtonActiv()"
                       type="default"
                       [text]="applyButtonText()"
                       [hint]="applyButtonHint"
                       (onClick)="applyDataSourceChanges()">
            </dx-button>
          </div>
        </div>
        <div *dxTemplate="let toolbaritem of 'exportDataSourceButtonTemplate'">
          <div id="exportDataSourceButton" class="d-flex gap-2">
            <dx-button stylingMode="text"
                       type="default"
                       icon="export"
                       text="{{ 'Excel Export' | translate }}"
                       (onClick)="exportDataSource()">

            </dx-button>
          </div>
        </div>
        <div *dxTemplate="let toolbaritem of 'importDataSourceButtonTemplate'">
          <div id="importDataSourceButton" class="d-flex gap-2">
            <dx-button stylingMode="text"
                       type="default"
                       icon="import"
                       text="{{ 'Excel Import' | translate }}"
                       (onClick)="showImportDataSource()">

            </dx-button>
          </div>
        </div>


        <dxi-column dataField="logoFile" caption="" [width]="60" [allowFiltering]="false" [allowSorting]="false" cellTemplate="imageCellTemplate"></dxi-column>
        <div *dxTemplate="let data of 'imageCellTemplate'" style="overflow:visible">
          <div>
            <span *ngIf="!data.value" class="glyphicon glyphicon-picture" style="font-size: 40px;"></span>
            <img *ngIf="data.value" src="{{data.value}}" style="height: 40px;" id="link{{data.rowIndex}}" />
          </div>
        </div>

        <dxi-column title="{{ 'KreditorNr' | translate }}" dataField="kreditorNr"></dxi-column>
        <dxi-column title="{{ 'Name' | translate }}" dataField="name"></dxi-column>
        <dxi-column title="{{ 'Typ' | translate }}" dataField="type" [calculateDisplayValue]="typeDisplay"></dxi-column>
        <dxi-column title="{{ 'Alternative Namen' | translate }}" dataField="alternativeNames"></dxi-column>
        <dxi-column dataField="lastUpdate"
                    dataType="datetime"
                    caption="{{ 'Letzte Ändernung' | translate }}"
                    editCellTemplate="lastUpdateTemplate"
                    showEditorAlways="true"
                    [allowEditing]="false">
        </dxi-column>
        <div *dxTemplate="let cellInfo of 'lastUpdateTemplate'">
          <dx-date-box [(value)]="cellInfo.value"
                       (onValueChanged)="cellInfo.setValue($event.value)"
                       type="datetime"
                       [readOnly]="true"></dx-date-box>
        </div>
        <dxi-column dataField="lastSync"
                    dataType="datetime"
                    caption="{{ 'Letzte Synchronisierung' | translate }}"
                    editCellTemplate="lastSyncTemplate"
                    showEditorAlways="true"
                    [allowEditing]="false">
        </dxi-column>
        <div *dxTemplate="let cellInfo of 'lastSyncTemplate'">
          <dx-date-box [(value)]="cellInfo.value"
                       (onValueChanged)="cellInfo.setValue($event.value)"
                       type="datetime"
                       [readOnly]="true"></dx-date-box>
        </div>
        <dxi-column caption="{{ 'Sicherheitsinformationen gepflegt?' | translate }}" cellTemplate="smileyTemplate">
          <div *dxTemplate="let cell of 'smileyTemplate'">
            <span class="smiley"
                  [ngClass]="getSmileyClass(cell.data)">
              {{ getSmileyEmoji(cell.data) }}
            </span>
          </div>
        </dxi-column>
        <dxi-column caption="" width="40" cellTemplate="editDataSourceTemplate"></dxi-column>
        <div *dxTemplate="let d of 'editDataSourceTemplate'">
          <a (click)="showAddOrUpdateDataSource(d.data)"
             class="dx-icon-edit mr-2"
             title="{{ 'Lieferant bearbeiten' | translate }}"></a>
        </div>
      </dx-data-grid>
    </div>
  </content-column>
  <app-edit-datasource [(visible)]="popupVisible"
                       [editMode]="editMode"
                       [dataSource]="newOrUpdateProductDataSource"
                       [relatedBrands]="relatedBrands"
                       [types]="types"
                       [countryCodes]="countryCodes"
                       (saved)="onEditSaved($event)">
  </app-edit-datasource>

  <dx-popup [(visible)]="startMacroDialogVisible"
            [width]="400"
            [height]="250"
            [title]="hasSelection ? ('Synchronisierung starten' | translate) : ('Alle Änderungen anwenden' | translate)"
            [hideOnOutsideClick]="true">

    <dxi-popup-toolbar-item toolbar="bottom"
                      location="after"
                      widget="dxButton"
                      [options]="{ text: hasSelection ? ('Synchronisierung starten' | translate) : ('Alle Änderungen anwenden' | translate), onClick: startApplyChangesMakro }">
    </dxi-popup-toolbar-item>
    <div *dxTemplate="let data of 'content'">
      <p>{{ 'Wird kein Startdatum angegeben, wird das Makro direkt ausgeführt.' | translate}}</p>
      <div class="dx-field">
        <div class="dx-field-label">{{ 'Startzeitpunkt' | translate }}</div>
        <div class="dx-field-value">
          <dx-date-box [(value)]="selectedMacroStartDate"
                       type="datetime"
                       displayFormat="dd.MM.yyyy HH:mm">
          </dx-date-box>
        </div>
      </div>
    </div>
  </dx-popup>
</fullscreen-page>

<dx-popup *ngIf="importExcelVisible"
          [width]="600"
          [height]="350"
          [showTitle]="true"
          title="{{ 'Lieferanten importieren' | translate }}"
          [dragEnabled]="false"
          [hideOnOutsideClick]="true"
          [showCloseButton]="true"
          [(visible)]="importExcelVisible"
          contentTemplate="popupContent2">
  <div *dxTemplate="let data of 'popupContent2'">
    <dx-file-uploader #fileUploader
                      name="file"
                      uploadUrl="api/import/ImportDataSourcesChunky"
                      [multiple]="false"
                      [chunkSize]="10000000"
                      accept=".xlsx"
                      (onUploaded)="onImportUploaded()"
                      uploadMode="instantly"
                      (onBeforeSend)="onBeforeSendUpload($event)">
    </dx-file-uploader>
  </div>
</dx-popup>
